import React, { useState, useEffect } from "react";
import TimeZones from "../../constants/TimeZones";
import TextInput from "../TextInput";
import SelectInputSearch from "../utilities/SelectInputSearch";

import { errorHandler } from "../ErrorHandler";
import ApiCall from "../../constants/Api";
import { helpAxios } from "../../helpers/helpAxios";
import SiteConfig from "../../constants/SiteConfig";
import { useSelectFunctions } from "../../functions";

const NewTrackModal = ({
  newTrack,
  setNewTrack,
  trackCategoryCbx,
  gameProviders,
  data,
  handleInsertTrack,
  countries,
}) => {
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [statesCountry, setStatesCountry] = useState([]);
  const { getStatesList } = useSelectFunctions();

  let trackCodeError, trackNameError, pastPostError;

  if (newTrack.errors) {
    if (newTrack.errors.trackCode) trackCodeError = newTrack.errors.trackCode;
    if (newTrack.errors.trackName) trackNameError = newTrack.errors.trackName;
    if (newTrack.errors.pastPost) pastPostError = newTrack.errors.pastPost;
  }

  //Onchange New Track
  const onChangeNewTrack = (e) => {
    let { name, value } = e.target;

    if (
      name === "TrackCode" ||
      name === "ShortName" ||
      name === "AmtoteTrackCode"
    ) {
      value = value.toUpperCase();
    }

    if (name === "DefaultPostCutoff") {
      value = value.replace(/\D/g, "");
      value = value ? parseInt(value, 10) : "";
    }

    setNewTrack({
      ...newTrack,
      [name]: value,
      LogonSessionID: data.LogonSessionID,
      Change: true,
    });
  };

  //Onchange Enabled Checkbox
  const handleCheckboxEnabledChange = (e) => {
    setNewTrack({
      ...newTrack,
      Enabled: e.target.checked,
      Change: true,
    });
  };

  //Onchange Special Event Checkboxes
  const handleCheckboxSpecialEventChange = (e) => {
    setNewTrack({
      ...newTrack,
      SpecialEvent: e.target.checked,
      Change: true,
    });
  };

  //Clean Inputs New Track Modal
  const cleanInputs = () => {
    setNewTrack({
      LogonSessionID: "",
      Enabled: true,
      TrackName: "",
      TrackCode: "",
      ShortName: "",
      TrackTimeZone: "Dateline Standard Time",
      DefaultCloseMethod: 1,
      DefaultPostCutoff: 0,
      TrackType: 0,
      IdTrackCategory: 1,
      LastModification: "",
      IdGameProvider: 1,
      SpecialEvent: false,
      AmtoteTrackCode: "",
      CountryCode: "",
      StateCode: "",
      ScoringRule: 0,
    });
  };

  // Countries and States
  useEffect(() => {
    const options = countries.map((option) => ({
      value: option.CountryCode,
      label: option.CountryCode + ": " + option.CountryName,
    }));
    const finalOptions = [...options];

    setCountryOptions(finalOptions);
  }, [countries]);

  const getStatesCountry = async (countryCode) => {
    const res = await getStatesList(
      {
        CountryCode: countryCode,
      },
      data.LogonSessionID,
    );

    if (!res.error) {
      setStatesCountry(res.States);
    }
  };

  useEffect(() => {
    const options = statesCountry.map((state) => ({
      value: state.StateCode,
      label: state.StateCode + ": " + state.StateName,
    }));
    const finalOptions = [...options];

    setStateOptions(finalOptions);
  }, [statesCountry]);

  //Onchange Tracks Table
  const handleCountryChange = (options) => {
    setNewTrack({
      ...newTrack,
      CountryCode: options.value,
      Change: true,
    });

    getStatesCountry(options.value);
  };

  const handleStateChange = (options) => {
    setNewTrack({
      ...newTrack,
      StateCode: options.value,
      Change: true,
    });
  };

  return (
    <>
      <div
        className="modal fade"
        id="newTrackModal"
        role="dialog"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
        aria-modal="true"
        tabIndex="-1"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          zIndex: 1051,
        }}
      >
        <div className="modal-dialog modal-md" style={{ margin: "4rem auto" }}>
          <div className="modal-content">
            <div
              className="modal-header"
              style={{ backgroundColor: "#5b6671", color: "#fff" }}
            >
              <h5 className="modal-title" id="newTrackModal">
                New Track
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => cleanInputs()}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {/* Left Column */}
                <div className="col-md-6">
                  <form autoComplete="off">
                    {/* Enabled */}
                    <div
                      className="form-group form-check"
                      style={{ paddingLeft: "0px" }}
                    >
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="switchEnabled"
                          name="Enabled"
                          checked={newTrack.Enabled}
                          onChange={(e) => handleCheckboxEnabledChange(e)}
                        />
                        <label
                          className="custom-control-label lead"
                          htmlFor="switchEnabled"
                        >
                          Enabled
                        </label>
                      </div>
                    </div>
                    {/* Provider */}
                    <div className="form-group">
                      <label className="lead">Provider</label>
                      <select
                        id="IdGameProvider"
                        name="IdGameProvider"
                        className="form-control"
                        value={newTrack.IdGameProvider}
                        onChange={(e) => onChangeNewTrack(e)}
                        style={{ fontSize: "14px" }}
                      >
                        {gameProviders.map((provider, i) => {
                          return (
                            <option key={i} value={provider.IDGameProvider}>
                              {provider.Description}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {/* Track Type */}
                    <div className="form-group">
                      <label className="lead">Track Type</label>
                      <select
                        className="form-control"
                        id="TrackType"
                        name="TrackType"
                        value={newTrack.TrackType}
                        onChange={(e) => onChangeNewTrack(e)}
                        style={{ fontSize: "14px" }}
                      >
                        <option value={0}>Thoroughbred</option>
                        <option value={1}>Harness</option>
                        <option value={2}>Greyhounds</option>
                      </select>
                    </div>
                    {/* Track Code */}
                    <div className="form-group">
                      <TextInput
                        id="TrackCode"
                        label="Track Code"
                        name="TrackCode"
                        type="text"
                        onChange={(e) => onChangeNewTrack(e)}
                        error={trackCodeError}
                        value={newTrack.TrackCode}
                        changeColor={true}
                        maxLength={5}
                        disabled={false}
                      />
                    </div>
                    {/* Track Name */}
                    <div className="form-group">
                      <TextInput
                        id="TrackName"
                        label="Track Name"
                        name="TrackName"
                        type="text"
                        onChange={(e) => onChangeNewTrack(e)}
                        error={trackNameError}
                        value={newTrack.TrackName}
                        changeColor={true}
                        maxLength={50}
                      />
                    </div>
                    {/* Short Name */}
                    <div className="form-group">
                      <label className="lead">Short Name</label>
                      <input
                        className="form-control"
                        id="ShortName"
                        name="ShortName"
                        type="text"
                        onChange={(e) => onChangeNewTrack(e)}
                        value={newTrack.ShortName}
                        maxLength={6}
                      />
                    </div>
                    {/* Country */}
                    <div className="form-group">
                      <label className="lead">Country</label>
                      <SelectInputSearch
                        id="selectedCountry"
                        name="CountryCode"
                        onChange={handleCountryChange}
                        optionsSelect={countryOptions}
                        value={newTrack.CountryCode}
                        placeholder="Select a Country"
                      />
                    </div>
                    {/* Scoring Rule */}
                    <div className="form-group">
                      <label className="lead"> Scoring Rule</label>
                      <select
                        className="form-control"
                        id="ScoringRule"
                        name="ScoringRule"
                        value={newTrack.ScoringRule}
                        onChange={(e) => onChangeNewTrack(e)}
                        style={{
                          fontSize: "14px",
                          padding: "0.61rem 0.75rem",
                        }}
                      >
                        <option value={0}>AllStatePicks</option>
                        <option value={1}>ExceptPick3</option>
                        <option value={2}>FairGrounds</option>
                      </select>
                    </div>
                  </form>
                </div>
                {/* Right Column */}
                <div className="col-md-6">
                  <form autoComplete="off">
                    {/* Special Event */}
                    <div
                      className="form-group form-check"
                      style={{ paddingLeft: "0px" }}
                    >
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="switchSpecialEvent"
                          name="SpecialEvent"
                          checked={newTrack.SpecialEvent}
                          onChange={(e) => handleCheckboxSpecialEventChange(e)}
                        />
                        <label
                          className="custom-control-label lead"
                          htmlFor="switchSpecialEvent"
                        >
                          Special Event
                        </label>
                      </div>
                    </div>
                    {/* Category */}
                    <div className="form-group">
                      <label className="lead">Category</label>
                      <select
                        id="IdTrackCategory"
                        name="IdTrackCategory"
                        className="form-control"
                        onChange={(e) => onChangeNewTrack(e)}
                        value={newTrack.IdTrackCategory}
                        style={{ fontSize: "14px" }}
                      >
                        {trackCategoryCbx.map((category, i) => {
                          return (
                            <option key={i} value={category.IDTrackCategory}>
                              {category.Description}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {/* Time Zone */}
                    <div className="form-group">
                      <label className="lead">Time Zone</label>
                      <select
                        id="TrackTimeZone"
                        name="TrackTimeZone"
                        className="form-control"
                        onChange={(e) => onChangeNewTrack(e)}
                        value={newTrack.TrackTimeZone}
                        style={{ fontSize: "14px" }}
                      >
                        {TimeZones.map((tz, i) => {
                          return (
                            <option key={i} value={tz}>
                              {tz}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {/* Close Method */}
                    <div className="form-group">
                      <label className="lead">Close Method</label>
                      <select
                        className="form-control"
                        id="DefaultCloseMethod"
                        name="DefaultCloseMethod"
                        style={{ fontSize: "14px" }}
                        onChange={(e) => onChangeNewTrack(e)}
                        value={newTrack.DefaultCloseMethod}
                      >
                        <option value={1}>Feed</option>
                        <option value={0}>Post Time</option>
                        <option value={2}>3 MTP</option>
                        <option value={3}>2 MTP</option>
                        <option value={4}>1 MTP</option>
                        <option value={5}>0 MTP</option>
                      </select>
                    </div>
                    {/* Past Post */}
                    <div className="form-group">
                      <TextInput
                        id="DefaultPostCutoff"
                        label="Past Post"
                        name="DefaultPostCutoff"
                        type="number"
                        onChange={(e) => onChangeNewTrack(e)}
                        error={pastPostError}
                        value={newTrack.DefaultPostCutoff}
                        changeColor={true}
                      />
                    </div>
                    {/* Tote Track Code */}
                    <div className="form-group">
                      <label className="lead">Tote Track Code</label>
                      <input
                        className="form-control"
                        type="text"
                        name="AmtoteTrackCode"
                        onChange={(e) => onChangeNewTrack(e)}
                        value={newTrack.AmtoteTrackCode}
                        maxLength={3}
                      />
                    </div>
                    {/* States */}
                    <div className="form-group">
                      <label className="lead"> State</label>
                      <SelectInputSearch
                        id="selectedState"
                        onChange={handleStateChange}
                        name="StateCode"
                        optionsSelect={stateOptions}
                        value={newTrack.StateCode}
                        placeholder="Select a State"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={() => handleInsertTrack(newTrack)}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => cleanInputs()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewTrackModal;
